const routerPath = {
  routes: [
    {
      path: '/',
      name: '/',
      meta: {
        keepAlive: false,
        layoutHeader: true
      },
      component: () => import('@/components/home')
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        keepAlive: false,
        layoutHeader: true
      },
      component: () => import('@/components/home')
    },
    {
      path: '/product',
      name: 'product',
      meta: {
        keepAlive: false,
        layoutHeader: true
      },
      component: () => import('@/components/product')
    },
    {
      path: '/productDetil',
      name: 'productDetil',
      meta: {
        keepAlive: false,
        layoutHeader: false
      },
      component: () => import('@/components/productDetil')
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        keepAlive: false,
        layoutHeader: true
      },
      component: () => import('@/components/about')
    },
    {
      path: '/news',
      name: 'news',
      meta: {
        keepAlive: false,
        layoutHeader: true
      },
      component: () => import('@/components/news')
    },
    {
      path: '/newsDetil',
      name: 'newsDetil',
      meta: {
        keepAlive: false,
        layoutHeader: true
      },
      component: () => import('@/components/newsDetil')
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {
        keepAlive: false,
        layoutHeader: true
      },
      component: () => import('@/components/contact')
    },
    {
      path: '/promotion',
      name: 'promotion',
      meta: {
        keepAlive: false,
        layoutHeader: false,
        name:'promotion'
      },
      component: () => import('@/components/promotion')
    },
  ]
}

export default routerPath


// WEBPACK FOOTER //
// ./src/router/routePath.js